import _ from "lodash";
import Accessor from "./Accessor";
import ZJSObject from "./ZJSObject";

class QsX {

  /**
   * 
   * @param {String} queryString 
   * @returns {*}
   */
  static Parse(queryString){

    if(_.isEmpty(queryString)) return {};
    let qS = queryString.slice(1);

    let rtn = {};

    let qSSplited = qS.split("&");
    _.map(qSSplited, (o, i) => {
      let splited = o.split("=");
      if(splited.length === 2){
        let first = decodeURIComponent(splited[0]);
        if(first.length === 0) return;
        let second = decodeURIComponent(splited[1]);
        let origin = Accessor.Get(rtn, first);
        if(!origin) Accessor.Set(rtn, first, second);
        else if(_.isArray(origin)) Accessor.Set(rtn, first, [...origin, second]);
        else Accessor.Set(rtn, first, [origin, second]);
      }
    });

    return rtn;
  }

  static Create(data){
    if(_.isEmpty(data)) return "";
    data = ZJSObject.RemoveUndefined(data);
    if(_.isEmpty(data)) return "";

    let rtn = "?";
    let dataStr = [];
    _.map(data, (o, i) => {
      dataStr.push(i.toString() + "=" + o.toString());
    });

    rtn += dataStr.join("&");
    return rtn;
  }

}

export default QsX;